import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsTriathlonNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M6.34 13.98h-.96a.993.993 0 01-1.71 0h-.96a.993.993 0 01-1.71 0v1.32c.266.124.556.189.85.19.493 0 .968-.186 1.33-.52a2.048 2.048 0 002.67 0 2 2 0 002.15.35v-1.27a.983.983 0 01-1.66-.07zm0-2.64h-.96a.989.989 0 01-1.71 0h-.96a.985.985 0 01-1.71 0v1.32c.266.124.556.189.85.19a1.92 1.92 0 001.33-.52 2.025 2.025 0 002.67 0 2 2 0 002.15.35v-1.27a.979.979 0 01-1.66-.07zM6.44 9H5.29a.982.982 0 01-1.52 0H2.62A.987.987 0 011 8.87v1.32c.266.124.556.189.85.19.05.002.1-.002.15-.01.184-.01.366-.048.54-.11.237-.09.455-.227.64-.4.208.19.458.327.73.4.403.13.837.13 1.24 0 .261-.077.5-.214.7-.4.196.18.428.316.68.4.21.08.434.12.66.12.279 0 .555-.057.81-.17V8.94A.969.969 0 016.44 9zm4.3-1.5a2.5 2.5 0 10-.82-4.86L8.75.42H7.61l.57 1.08H6.87l-.53-1H5v1h.73l.26.5-.3.6A2.26 2.26 0 005 2.5a2.5 2.5 0 101.58.56l.28-.56H8.7l.35.66a2.5 2.5 0 001.69 4.34zM6.5 5a1.541 1.541 0 11-1.29-1.48L4.46 5h1.12l.52-1.01c.259.272.402.634.4 1.01zm3.52 0h1.14l-.77-1.45c.113-.037.231-.054.35-.05A1.5 1.5 0 119.24 5a1.424 1.424 0 01.31-.9l.47.9zm5.38 9.32l-2.19-4.11a1.076 1.076 0 00-1.42-.43l-.17-.54a.9.9 0 00-.84-.74.921.921 0 00-.85.59l-.47 1.15-.15.08a1 1 0 00-.31.34.207.207 0 00-.06.1 1.1 1.1 0 00-.15.43.355.355 0 00-.02.1c-.012.123-.008.248.01.37.017.092.044.183.08.27.033.09.08.175.14.25.03.063.071.12.12.17l1.93 2.1a3.553 3.553 0 002.5 1.05h1.14a.8.8 0 00.71-1.18zm-1.85.18a2.546 2.546 0 01-1.78-.74l-1.91-2.09a.382.382 0 01-.1-.29.414.414 0 01.09-.22l.4-.22.46-1.25.6 1.81h.55l.21-.43.26-.39 2.03 3.82h-.81z"
        fill=""
      />
    </svg>
  )
);
SvgSportsTriathlonNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsTriathlonNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsTriathlonNormalXsmall;
